module.exports = __webpack_public_path__ + "static/media/14.jpg.0e3eb14f.webp";